export default "__VITE_ASSET__DBYEbS2H__"